import type { Bgm } from '@ssml-editor/editor-vue';

export default <Bgm[]>[
  {
    name: 'cirque',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/cirque.wav',
  },
  {
    name: 'dolphin ride',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/dolphin-ride-short.wav',
  },
  {
    name: 'four on six',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/Four%20on%20Six.wav',
  },
  {
    name: 'happy birthday',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/happy-birthday.wav',
  },
  {
    name: 'happy strike',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/happy-strike.wav',
  },
  {
    name: 'jk pallas',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/jk-pallas.wav',
  },
  {
    name: 'musique electronique',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/musique-electronique.wav',
  },
  {
    name: '泰迪熊的野餐',
    src: 'https://ssml-editor-prd.oss-cn-huhehaote.aliyuncs.com/music/public/%E6%B3%B0%E8%BF%AA%E7%86%8A%E7%9A%84%E9%87%8E%E9%A4%90.wav',
  },
];
